import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --header-bg: #141925;
    --navbar-bg: #1A1D26;
    --sidebar-bg: #0B0D13;
    --main-bg: #141925;
    --chat-bg: #151A2D;
    --stats-bg: #1E2233;
    --yellow: #FFB800;
    --orange: #FFA500;
    --text-light: #a8b2d1;
    --text-white: #ffffff;
    --border-dark: #2d3039;
    --border-light: #4f5983;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Roboto Condensed', sans-serif;
  }

  body {
    color: var(--text-light);
  }
`; 